<template>
  <div class="modalContents__object03">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
          <h2 class="text-center">
            <img
              class="img-fluid"
              src="/images/common/reg.png"
              width="656"
              height="206"
              alt="新規会員登録"
            >
            <strong>{{ isLogged ? '会員情報変更' : '新規会員登録' }}</strong>
          </h2>

          <p>
            NO BORDERの会員になると、アーカイブされた動画をご視聴可能になれるプラン、
            メールマガジン購読プランなどのご契約が可能です。
            <!-- ご質問は、
            <a href="tel:03-6721-1468">03-6721-1468</a>（受付時間：平日10時～17時）までお問い合わせ下さい。 -->
          </p>

          <h3 class="text-center" v-if="!isLogged">SNSから登録</h3>

          <div class="modalContents__object03--ex01">
            <div class="row">
              <div class="modalContents__object03__btn" v-if="!isLogged">
                <a
                  href="javascript:void(0)"
                  class="globalModal--btn"
                  title="close"
                  @click="hideModal"
                >
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                    <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
              <div class="modalContents__object03__btn-ex" v-else-if="isLogged">
                <a
                  href="javascript:void(0)"
                  class="globalModal--btn"
                  title="close"
                  @click="hideModal"
                >
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                    <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="row no-gutters">
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/line" class="btn text-center" style="background:#00c402;">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 448 512" style="enable-background:new 0 0 448 512;" xml:space="preserve"><path d="M272.1,204.2v71.1c0,1.8-1.4,3.2-3.2,3.2h-11.4c-1.1,0-2.1-0.6-2.6-1.3l-32.6-44v42.2c0,1.8-1.4,3.2-3.2,3.2h-11.4 c-1.8,0-3.2-1.4-3.2-3.2v-71.1c0-1.8,1.4-3.2,3.2-3.2H219c1,0,2.1,0.5,2.6,1.4l32.6,44v-42.2c0-1.8,1.4-3.2,3.2-3.2h11.4 C270.6,201,272.1,202.5,272.1,204.2L272.1,204.2z M190.1,201h-11.4c-1.8,0-3.2,1.4-3.2,3.2v71.1c0,1.8,1.4,3.2,3.2,3.2h11.4 c1.8,0,3.2-1.4,3.2-3.2v-71.1C193.3,202.5,191.9,201,190.1,201L190.1,201z M162.6,260.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4 c-1.8,0-3.2,1.4-3.2,3.2v71.1c0,0.9,0.3,1.6,0.9,2.2c0.6,0.5,1.3,0.9,2.2,0.9h45.7c1.8,0,3.2-1.4,3.2-3.2v-11.4 C165.7,262.1,164.3,260.6,162.6,260.6L162.6,260.6z M332.1,201h-45.7c-1.7,0-3.2,1.4-3.2,3.2v71.1c0,1.7,1.4,3.2,3.2,3.2h45.7 c1.8,0,3.2-1.4,3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8,0,3.2-1.4,3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1 c1.8,0,3.2-1.4,3.2-3.2v-11.4C335.2,202.5,333.8,201,332.1,201L332.1,201z M448,113.7V399c-0.1,44.8-36.8,81.1-81.7,81H81 c-44.8-0.1-81.1-36.9-81-81.7V113c0.1-44.8,36.9-81.1,81.7-81H367C411.8,32.1,448.1,68.8,448,113.7z M386.4,236.3 c0-73-73.2-132.4-163.1-132.4S60.2,163.3,60.2,236.3c0,65.4,58,120.2,136.4,130.6c19.1,4.1,16.9,11.1,12.6,36.8 c-0.7,4.1-3.3,16.1,14.1,8.8c17.4-7.3,93.9-55.3,128.2-94.7C375.1,291.8,386.4,265.5,386.4,236.3z"/></svg>
                  <br>LINEで登録</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/twitter" class="btn text-center" style="background: #1da1f2;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>
                  <br>Twitterで登録</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/facebook" class="btn text-center" style="background:#4267b2;">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 448 512" style="enable-background:new 0 0 448 512;" xml:space="preserve"><path d="M448,80v352c0,26.5-21.5,48-48,48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6,5.4-32.9,33.5-32.9H384V98.7 c-6.2-0.8-27.4-2.7-52.2-2.7c-51.6,0-87,31.5-87,89.4v49.9H184v67.6h60.9V480H48c-26.5,0-48-21.5-48-48V80c0-26.5,21.5-48,48-48h352 C426.5,32,448,53.5,448,80z"/>
                    </svg>
                  <br>Facebookで登録</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/google" class="btn text-center">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 488 512" style="enable-background:new 0 0 488 512;" xml:space="preserve"><path d="M454.6,261c0,122.1-83.6,209.1-207.2,209.1C129,470.1,33.4,374.4,33.4,256S129,41.9,247.5,41.9c57.7,0,106.2,21.1,143.5,56 l-58.3,56c-76.2-73.5-218-18.3-218,102c0,74.7,59.6,135.2,132.7,135.2c84.8,0,116.5-60.8,121.5-92.3H247.5v-73.6h203.8 C453.2,236.2,454.6,246.8,454.6,261L454.6,261z"/></svg>
                  <br>Googleで登録</a>
                </div>
              </div>
            </div>
          </div>
          <div class="modalContents__object03--ex02 col-12 text-center">OR</div>
          <hr v-if="!isLogged">>

          <h3 class="text-center">{{ isLogged ? 'DATA EDIT' : 'DATA ENTRY' }}</h3>

          <form id="signup01_form" class="row no-gutters" @submit.prevent="send">
            <!-- <div class="modalContents__object03__btn">
              <a
                href="javascript:void(0)"
                class="globalModal--btn"
                title="close"
                @click="hideModal"
              >
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                  <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                </span>
              </a>
            </div> -->
            <h4 class="col-10 mr-auto">■ 登録情報</h4>
            <!-- お名前 -->
            <div class="col-6 modalContents__object03--position01">
              <label for="lastname">姓（15文字以内）</label>
              <input
                type="text"
                name="lastname"
                id="lastname"
                class="form-control"
                placeholder="姓（15文字以内）"
                v-model="last_name"
                v-on:blur="check_last_name()"
              >
              <p v-if="errors.last_name" class="error_message text-danger">{{ errors.last_name }}</p>
            </div>
            <div class="col-6 modalContents__object03--position02">
              <label for="firstname">名（15文字以内）</label>
              <input
                type="text"
                name="firstname"
                id="firstname"
                class="form-control"
                placeholder="名（15文字以内）"
                v-model="first_name"
                v-on:blur="check_first_name()"
              >
              <p v-if="errors.first_name" class="error_message text-danger">{{ errors.first_name }}</p>
            </div>
            <!-- メール -->
            <div class="col-12" v-if="!social_login">
              <label for="bemailSingup">メールアドレス</label>
              <input
                type="text"
                name="bemailSingup"
                id="bemailSingup"
                class="form-control"
                placeholder="MAIL ADDRESS"
                v-model="email"
                v-on:blur="check_email()"
              >
              <p v-if="errors.email" class="error_message text-danger">{{ errors.email }}</p>
            </div>
            <div class="col-12" v-if="!social_login">
              <label for="bemailSingup2">メールアドレス再入力</label>
              <input
                type="text"
                name="bemailSingup2"
                id="bemailSingup2"
                class="form-control"
                placeholder="MAIL ADDRESS"
                v-model="email_confirm"
                v-on:blur="check_email_confirm()"
              >
              <p v-if="errors.email_confirm" class="error_message text-danger">{{ errors.email_confirm }}</p>
            </div>
            <!-- 電話 -->
            <div class="col-12">
              <label for="phone">電話番号（ハイフン「-」不要）</label>
              <input type="text" name="phone" id="phone" class="form-control" placeholder="TEL"
                v-model="phone"
                v-on:blur="check_phone()"
              >
              <p v-if="errors.phone" class="error_message text-danger">{{ errors.phone }}</p>
            </div>
            <!-- パスワード -->
            <div class="col-xs-6 col-12 modalContents__object03--position04" v-if="!social_login">
              <label for="passwordSingup">パスワード（6〜12文字の英数字）</label>
              <input
                type="password"
                name="passwordSingup"
                id="passwordSingup"
                class="form-control"
                placeholder="6〜12文字英数字"
                v-model="password"
                v-on:blur="check_password()"
              >
              <p v-if="errors.password" class="error_message text-danger">{{ errors.password }}</p>
            </div>
            <div class="col-xs-6 col-12 modalContents__object03--position03" v-if="!social_login">
              <label for="passwordSingup2">パスワード再入力</label>
              <input
                type="password"
                name="passwordSingup2"
                id="passwordSingup2"
                class="form-control"
                placeholder="確認用再入力"
                v-model="password_confirm"
                v-on:blur="check_password_confirm()"
              >
              <p v-if="errors.password_confirm" class="error_message text-danger">{{ errors.password_confirm }}</p>
            </div>
            <div class="col-md-9 row no-gutters">
              <label class="col-12">生年月日</label>
              <div class="col-4 modalContents__object03--position01">
                <div class="modalContents__object03--select">
                  <select name="birthyear" id="birthyear" class="form-control" v-model='birth_y'>
                    <option value>西暦</option>
                    <option v-for="i in yearsForSelect" :value="i" :key="i">{{ i }}年</option>
                  </select>
                </div>
              </div>
              <div
                class="col-4 modalContents__object03--position01 modalContents__object03--position02"
              >
                <div class="modalContents__object03--select">
                  <select name="birthmonth" id="birthmonth" class="form-control" v-model='birth_m'>
                    <option value>月</option>
                    <option v-for="i in 12" :value="i" :key="i">{{ i }}月</option>
                  </select>
                </div>
              </div>
              <div
                class="col-4 modalContents__object03--position02 modalContents__object03--position03"
              >
                <div class="modalContents__object03--select">
                  <select name="birthday" id="birthday" class="form-control" v-model='birth_d'>
                    <option value>日</option>
                    <option v-for="i in 31" :value="i" :key="i">{{ i }}日</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 性別 -->
            <div class="col-md-3 row no-gutters">
              <label for="gender" class="col-12 modalContents__object03--position05">性別</label>
              <div class="col-md-12 col-4 mr-auto modalContents__object03--position05">
                <div class="modalContents__object03--select">
                  <select name="gender" id="gender" class="form-control"  v-model='gender'>
                    <option value>性別</option>
                    <option value="1">男性</option>
                    <option value="0">女性</option>
                    <option value="2">その他</option>
                  </select>
                </div>
              </div>
            </div>

            <p v-if="errors.birthday" class="error_message text-danger">{{ errors.birthday }}</p>
            <p v-if="errors.gender" class="error_message text-danger">{{ errors.gender }}</p>

            <!-- 次へボタン -->
            <div class="col-6 offset-6 modalContents__object03--position02" v-if="!isLogged">
              <button
                id="signup01_btn"
                class="text-center btn globalModal--btn"
              >次へ</button>
            </div>
            <!-- 次へボタン -->
            <div class="col-6 offset-6 modalContents__object03--position02" v-if="isLogged">
              <button
                id="signup01_btn"
                class="text-center btn globalModal--btn"
              >変更完了</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .error_message{
    font-size: 85%;
    padding-top: 6px;
    margin-bottom: 0;
  }
</style>

<script>
import { mapMutations } from "vuex";
import ModalMixin from "../mixins/ModalMixin";

const startYear = 1910;
const diffYear = new Date().getFullYear() - startYear;

export default {
  name: "personal",
  data: function() {

    var data = OPED.login_user ? OPED.login_user : {
      'last_name' : this.$store.state.inputData.last_name,
      'first_name' : this.$store.state.inputData.first_name,
      'email' : this.$store.state.inputData.email,
      'phone' : this.$store.state.inputData.phone,
      'birthday' : this.$store.state.inputData.birthday,
      'gender' : this.$store.state.inputData.gender,
    };


    return {

      ...data,

      errors : {
        last_name : '',
        first_name : '',
        email : '',
        email_confirm : '',
        phone : '',
        password : '',
        password_confirm : '',
        birthday : '',
        gender : '',
      },

      email_confirm:'',
      password:'',
      password_confirm:'',
      social_login:OPED.social_login,

      birth_y : '',
      birth_m : '',
      birth_d : '',


      yearsForSelect: [...Array(diffYear).keys()].map(i => i + startYear),
      isLogged: OPED.isLogged
    };
  },
  mixins: [ModalMixin],
  mounted () {
    //console.log(this);
    if(this.birthday){
      // 初期選択
      let birthday = moment(this.birthday);
      this.birth_y = birthday.years();
      this.birth_m = birthday.months()+1;
      this.birth_d = birthday.date();
      //console.log(birthday.days());
    }
  },
  methods: {
    check_last_name () {
      if(this.last_name == ''){
        this.errors.last_name = '姓は必ずご入力ください';
      }else{
        this.errors.last_name = '';
      }
    },
    check_first_name () {
      if(this.first_name == ''){
        this.errors.first_name = '名は必ずご入力ください';
      }else{
        this.errors.first_name = '';
      }
    },
    check_email () {
      if(this.email == ''){
        this.errors.email = 'メールアドレスは必ずご入力ください';
      }else{
        if(this.validEmail(this.email)){
          this.errors.email = '';
        }else{
          this.errors.email = '正しいメールアドレスをご入力ください';
        }
      }
    },

    check_email_confirm () {
      if(this.email_confirm == ''){
        this.errors.email_confirm = 'メールアドレスは必ずご入力ください';
      }else{
        if(this.validEmail(this.email_confirm)){

          if(this.email !== this.email_confirm){
            this.errors.email_confirm = 'メールアドレスを再度ご確認ください';
          }else{
            this.errors.email_confirm = '';
          }

        }else{
          this.errors.email_confirm = '正しいメールアドレスをご入力ください';
        }
      }
    },


    check_phone () {
      if(this.phone == ''){
        this.errors.phone = '電話番号は必ずご入力ください';
      }else{
        this.errors.phone = '';
      }
    },
    check_password () {
      if(this.password == ''){
        this.errors.password = 'パスワードは必ずご入力ください';
      }else{
        if(this.password.length < 6){
          this.errors.password = 'パスワードは６文字以上で設定してください。';
        }else{
          this.errors.password = '';
        }
      }
    },
    check_password_confirm () {
      if(this.password_confirm == ''){
        this.errors.password_confirm = 'パスワード(確認用)は必ずご入力ください';
      }else{
        if(this.password_confirm !== this.password){
          this.errors.password_confirm = '再度パスワードをご入力ください';
        }else{
          this.errors.password_confirm = '';
        }
      }
    },

    check_birthday () {
      if(this.birth_y != '' && this.birth_m != '' && this.birth_d != ''){
        if(moment(this.birth_y + "/" + this.birth_m + "/" + this.birth_d).isValid()){
          this.errors.birthday = '';
        }else{
          this.errors.birthday = '生年月日が正しく設定されてません。';
        }
      }else{
        this.errors.birthday = '生年月日が正しく設定されてません。';
      }
    },
    check_gender () {
      if(this.gender !== ''){
        this.errors.gender = '';
      }else{
        this.errors.gender = '性別は必ず選択してください';
      }
    },


    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    send() {
      this.check_last_name();
      this.check_first_name();
      if(!this.social_login){
        this.check_email();
        this.check_email_confirm();
      }
      this.check_phone();
      if(!this.social_login){
        this.check_password();
        this.check_password_confirm();
      }
      this.check_birthday();
      this.check_gender();

      if(!this.hasError()){
        if(this.isLogged){
          let params = {
            'last_name' : this.last_name,
            'first_name' : this.first_name,
            'email' : this.email,
            'phone' : this.phone,
            'password' : this.password,
            'gender' : this.gender,
            'birthday' : this.birth_y + '-' + this.birth_m + '-' + this.birth_d,
          }
          axios
            .post('/auth/edit',params)
            .then(response => {
              if(response.status == 200){
                // 送信完了
                console.log('contact submited')
              }
            })
            .catch(error => console.log(error))
          this.showModalEditThanks();
        }else{
          this.$store.state.inputData.last_name = this.last_name;
          this.$store.state.inputData.first_name = this.first_name;
          this.$store.state.inputData.email = this.email;
          this.$store.state.inputData.phone = this.phone;
          this.$store.state.inputData.password = this.password;
          this.$store.state.inputData.gender = this.gender;
          this.$store.state.inputData.birthday = this.birth_y + '-' + this.birth_m + '-' + this.birth_d;
          this.showModalPlan();
        }
      }

      // showModalPlan
    },

    hasError(){
      var isError = false;
      for(var err in this.errors){
        if(this.errors[err]){
          isError = true;
        }
      }
      return isError;
    },


  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/personal.vue